module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/0_icon-a9d28765caee197f336b9e1ff26340ed.png";